import React from 'react';
import {Chip, OutlinedInput, InputAdornment, Stack} from '@mui/material';
import {Search} from '@mui/icons-material';
import {useListContext} from 'components/list/ListContext';
import useIsMobile from 'hooks/useIsMobile';

const STATUS_OPTIONS = [
  {id: 'all', label: 'All'},
  {id: 'accept', label: 'Accepted'},
  {id: 'waiting', label: 'Waiting'},
  {id: 'reject', label: 'Rejected'}
];

const EntriesFilters = () => {
  const {addFilters, filters} = useListContext();
  const setFilters = addFilters ?? (() => undefined);
  const isMobile = useIsMobile();
  const [search, setSearch] = React.useState('');
  const active = filters?.status || 'all';

  return (
    <Stack spacing={1.5} sx={{mb: 1}}>
      <OutlinedInput
        size="small"
        value={search}
        onChange={(e) => setSearch(e.target.value)}
        placeholder="Search name / bib / club"
        startAdornment={
          <InputAdornment position="start">
            <Search fontSize="small" />
          </InputAdornment>
        }
        sx={{width: {xs: '100%', sm: 360}, maxWidth: '100%', backgroundColor: 'background.paper'}}
      />
      <Stack direction="row" gap={isMobile ? 0.5 : 1} flexWrap="wrap">
        {STATUS_OPTIONS.map((option) => {
          const selected = active === option.id;
          return (
            <Chip
              key={option.id}
              clickable
              label={option.label}
              onClick={() => setFilters({status: option.id})}
              sx={{
                fontWeight: selected ? 700 : 500,
                backgroundColor: selected ? 'rgba(255, 0, 102, 0.12)' : 'background.paper',
                color: selected ? 'primary.main' : 'text.primary',
                border: '1px solid',
                borderColor: selected ? 'rgba(255, 0, 102, 0.4)' : 'divider'
              }}
            />
          );
        })}
      </Stack>
    </Stack>
  );
};

export default EntriesFilters;
